import React from 'react';
import {Container, Row, Col} from 'reactstrap';

import './updatePaymentStyle.scss';
import BasicText from './basicText';
import BasicImage from './basicImage';

const DebtNotification = (props) => {
  const arrow = require(`./images/icons-arrow-private/icons-arrow-private.svg`);

  return (
    <Container className='paymentupdate-notification-container'>
      <Row>
        <Col>
          <BasicText text='שימו לב' bold />
        </Col>
      </Row>
      <Row>
        <Col>
          <BasicText text='על פי רישומנו הינך נדרש לשלם את החוב' />
        </Col>
      </Row>
      <Row onClick={props.debtPaymentMethod}>
        <Col className='paymentupdate-redirect-button'>
          <BasicText text={'לתשלום חוב'} bold color={'privatePink'} />
          <BasicImage src={arrow} classname='arrow-img' />
        </Col>
      </Row>
    </Container>
  );
};

export default DebtNotification;
